(() => {
  'use strict';
  const config = document.getElementById('vo-professional-products');
  const dialog = document.getElementById('vo-professional-dialog');
  if (!config || !dialog) return;
  const products = JSON.parse(config.textContent);
  const checkbox = dialog.querySelector('[data-pro-confirm]');
  const confirm = dialog.querySelector('[data-pro-add]');
  const description = dialog.querySelector('[data-pro-description]');
  let pending = null;
  let replaying = false;
  function match(form) {
    if (!(form instanceof HTMLFormElement)) return null;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return null;
    const id = String(new FormData(form).get('id') || '');
    return products.find(product => product.variants.some(variant => String(variant) === id));
  }
  function open(event, form, button, product) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (dialog.open) return;
    pending = {form, button, variant: String(new FormData(form).get('id')), focus: document.activeElement};
    checkbox.checked = false;
    confirm.disabled = true;
    description.textContent = product.name + ' is ' + product.description + '. It is not intended for DIY lash clusters or application on yourself.';
    dialog.showModal();
    document.documentElement.classList.add('vo-pro-open');
  }
  // Capture before the theme's product click handler and quick-add submit handler.
  window.addEventListener('click', event => {
    if (replaying || !(event.target instanceof Element)) return;
    const button = event.target.closest('button, input[type="submit"]');
    if (!button || button.disabled || !button.form || button.type !== 'submit') return;
    const product = match(button.form);
    if (product) open(event, button.form, button, product);
  }, true);
  window.addEventListener('submit', event => {
    if (replaying) return;
    const product = match(event.target);
    if (product) open(event, event.target, event.submitter, product);
  }, true);
  checkbox.addEventListener('change', () => { confirm.disabled = !checkbox.checked; });
  dialog.querySelectorAll('[data-pro-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => { if (event.target === dialog) { const box=dialog.getBoundingClientRect(); if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('vo-pro-open');
    checkbox.checked = false;
    confirm.disabled = true;
    if (pending?.focus?.isConnected) pending.focus.focus({preventScroll:true});
    pending = null;
  });
  confirm.addEventListener('click', () => {
    if (!checkbox.checked || !pending) return;
    const {form, button, variant} = pending;
    if (!form.isConnected || String(new FormData(form).get('id')) !== variant) { dialog.close(); return; }
    pending = null;
    dialog.close();
    document.documentElement.classList.remove('vo-pro-open');
    replaying = true;
    try {
      if (button?.isConnected && !button.disabled) button.click();
      else form.requestSubmit();
    } finally { replaying = false; }
  });
})();
